
import MiniPlayer from '@/components/music_player/MiniPlayer.vue'
import MusicPlayer from '@/components/music_player/MusicPlayer.vue'
import AssistiveDot from '@/components/music_player/AssistiveDot.vue'
import MusicListItem from './MusicListItem.vue'
import DownloadApp from './DownloadApp'
import filters from "@/filters";
import Popup from 'vux/src/components/popup/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


import { mapGetters, mapMutations } from 'vuex'

const markdown = filters.markdown;
const markdownIndent = (html) => html.replace(/\<p\>/g, `\<p style="text-indent:2em; text-align:left; margin-bottom: -5px;"\>`)

export default {
name: 'MusicController',
data () {
return {
isShow: false,
flag: false, //至少点击过一次
isShowDownload: false,
scroll: 0,
allowScroll: {
content: true,
musicList: false
}
}
},

watch: {
isShow: {
handler (newVal, oldVal) {
if (newVal) {












document.getElementById('app').style.display = 'none'
} else {




document.getElementById('app').style.display = ''
}
}
}
},

created () {


},

methods: {
...mapMutations([
'play',
'setCurrentAudio',
'pause',
'setAudioIndex',
'findIndexInAudioList',
'nextAudio',
'prevAudio'
]),

onSuccess () {

},

onScroll () {
this.scroll = this.$refs.popup.$el.scrollTop

if (this.scroll > 0) {
this.allowScroll.content = false
} else {
this.allowScroll.content = true
}


if (this.scroll < window.innerHeight - 225 + 45) {
this.allowScroll.musicList = false
} else {
this.allowScroll.musicList = true
}
},

onError () {


this.$vux.confirm.show({
title:　'下载APP',
content: '啊哦！此语音只能下载APP试听哦！',
confirmText:'前往下载',
cancelText:'继续查看',

onCancel () {
console.log('继续查看')
},
onConfirm () {
location.href = "http://www.xcz.im/"
}
})



},


clickNext () {

if (!this.isIndexInRange) {
this.findIndexInAudioList(this.currentAudio.audio)
}

this.nextAudio(this.PLAY_MODE.ORDER)
},

clickPrev () {
if (!this.isIndexInRange){
this.findIndexInAudioList(this.currentAudio.audio)
}

this.prevAudio()
},

onEnded () {



this.clickNext()
},

clickMusicListItem (index) {
if (!this.audioList[index]) {
throw new ReferenceError(`audioList[${index}] is not exist!`)
}

this.setAudioIndex(index)
this.play()   

this.setCurrentAudio(this.audioList[index])
},

hidePlayer () {
this.isShow = false
},

showPlayer () {
this.flag = true
this.isShow = true
},

whenWorkExist (action) {
let work = this.currentAudio.audio && this.currentAudio.audio.get('work')
let result = ""

if (work) {
result = action(work)
}

return result
},
},

computed: {
...mapGetters(['isPlay', 'currentAudio', 'currentAlbum', 'audioList', 'isIndexInRange', 'PLAY_MODE']),


src () {
let source = this.currentAudio.audio && this.currentAudio.audio.get('audioUrl')

if (source === "") {
this.onError()
this.isShowDownload = true
} else {
this.isShowDownload = false
}

return source
},

title () {
let title = this.whenWorkExist(work => work.get('title'))


if (title === "") {
title = this.currentAudio.audio && this.currentAudio.audio.get('title')
}

return title
},

content () {
let layout = null
let content = this.whenWorkExist(work => {
layout = work.get('layout')

return work.get('content')
})


if (content === "") {
content = this.currentAudio.audio && this.currentAudio.audio.get('desc')
content = markdown(content)
content = markdownIndent(content)
}
else {

content = markdown(content)
switch (layout) {
case 'indent':
content = markdownIndent(content)
break
case 'center':

break
}
}


return content.replace(/[\n\r]{2,}/g, '\n')
},

authorName () {
let authorName = this.whenWorkExist(work => work.get('authorName'))


if (authorName === "") {
authorName = this.currentAlbum && this.currentAlbum.get('xmAnnouncerName')
}

return authorName
},





ownner () {
return this.currentAlbum.get('xmAnnouncerName')
}
},

components: {
TransferDom,
MiniPlayer,
MusicPlayer,
AssistiveDot,
Popup,
XSwitch,
MusicListItem,
DownloadApp
}
}



// WEBPACK FOOTER //
// ./src/components/music_player/MusicController.vue